export default "__VITE_ASSET__56014419__"